import {adbApi} from "./adbService";

export const helpPageApi = adbApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllTrainingVideosPage: builder.query({
            query: () => ({
                url: "pages/help",
                method: "GET",
            }),
            invalidatesTags: ["trainingVideo"],
        }),
        getAllTrainingVideos: builder.query({
            query: () => ({
                url: "help-videos",
                method: "GET",
            }),
            invalidatesTags: ["trainingVideo"],
        }),
        createTrainingVideo: builder.mutation({
            query: (formData) => ({
                url: "help-videos",
                method: "POST",
                body: formData,
                formData: true,
            })
        }),
        updateTrainingVideo: builder.mutation({
            query: ({ formData, id }) => ({
                url: `help-videos/${id}`,
                method: "POST",
                body: formData,
                formData: true,
            }),
        }),
        deleteTrainingVideo: builder.mutation({
            query: (id) => ({
                url: `help-videos/${id}`,
                method: "DELETE",
            }),
        }),
    }),
    overrideExisting: false,
});

export const {
    useLazyGetAllTrainingVideosPageQuery,
    useLazyGetAllTrainingVideosQuery,
    useCreateTrainingVideoMutation,
    useUpdateTrainingVideoMutation,
    useDeleteTrainingVideoMutation,

} = helpPageApi;
